export default __webpack_public_path__ + "static/media/AI1 v1_discont.0d6cb123.png";